export class FirstVisit {
    static daysToStore = 365;

    static mainValue = 'first_visit_main'
    static admitadValue = 'first_visit_admitad'

    static currentTime = new Date().toISOString()

    constructor() {}

    private static setCookie(name: string, value: string, days: number) {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        const cookieBase = `${name}=${value}; path=/; expires=${expires}; SameSite=Lax`;

        // Установка cookie для текущего домена
        document.cookie = cookieBase;
    }

    private static getCookie(name: string): string | null {
        const nameEQ = `${name}=`;
        const cookies = document.cookie.split(';');

        for (let i = 0; i < cookies.length; i++) {
            const c = cookies[i].trim();

            if (c.startsWith(nameEQ)) {
                return decodeURIComponent(c.substring(nameEQ.length));
            }
        }

        return null;
    }

    private static getParamFromUrl(paramName: string) {
        const regex = new RegExp('[?&]' + paramName + '=([^&#]*)');
        const results = regex.exec(window.location.search);

        return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : '';
    }

    static setMainValues() {
        const key = FirstVisit.mainValue;

        const existingValue = FirstVisit.getCookie(key);

        // Если значение уже есть, не обновляем его, только продлеваем срок
        const valueToStore = existingValue || FirstVisit.currentTime;

        // Обновляем или устанавливаем куку с новым сроком действия (30 дней)
        FirstVisit.setCookie(key, valueToStore, FirstVisit.daysToStore);
    }

    static setAdmitadValues() {
        if (this.getParamFromUrl('utm_source') !== 'admitad') return;

        const key = FirstVisit.admitadValue;

        const existingValue = FirstVisit.getCookie(key);

        // Если значение уже есть, не обновляем его, только продлеваем срок
        const valueToStore = existingValue || FirstVisit.currentTime;

        // Обновляем или устанавливаем куку с новым сроком действия (30 дней)
        FirstVisit.setCookie(key, valueToStore, FirstVisit.daysToStore);
    }
}

